import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "export-pdf-dialog" }
const _hoisted_2 = { class: "thumbnails-view" }
const _hoisted_3 = {
  class: "thumbnails",
  ref: "pdfThumbnailsRef"
}
const _hoisted_4 = { class: "configs" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "config-item" }
const _hoisted_9 = { class: "btns" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThumbnailSlide = _resolveComponent("ThumbnailSlide")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_RadioGroup = _resolveComponent("RadioGroup")!
  const _component_SelectOption = _resolveComponent("SelectOption")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Switch = _resolveComponent("Switch")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.rangeType === 'current')
          ? (_openBlock(), _createBlock(_component_ThumbnailSlide, {
              key: 0,
              class: "thumbnail",
              slide: _ctx.currentSlide,
              size: 1600,
              selectIndex: _ctx.index
            }, null, 8, ["slide", "selectIndex"]))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.slides, (slide, index) => {
              return (_openBlock(), _createBlock(_component_ThumbnailSlide, {
                class: _normalizeClass(["thumbnail", { 'break-page': (index + 1) % _ctx.count === 0 }]),
                key: slide.id,
                slide: slide,
                size: 1600
              }, null, 8, ["class", "slide"]))
            }), 128))
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, "导出范围：", -1)),
        _createVNode(_component_RadioGroup, {
          class: "config-item",
          value: _ctx.rangeType,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rangeType) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_RadioButton, {
              style: {"width":"50%"},
              value: "all"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("全部幻灯片")
              ])),
              _: 1
            }),
            _createVNode(_component_RadioButton, {
              style: {"width":"50%"},
              value: "current"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("当前幻灯片")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title" }, "每页数量：", -1)),
        _createVNode(_component_Select, {
          class: "config-item",
          value: _ctx.count,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.count) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SelectOption, { value: 1 }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("1")
              ])),
              _: 1
            }),
            _createVNode(_component_SelectOption, { value: 2 }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("2")
              ])),
              _: 1
            }),
            _createVNode(_component_SelectOption, { value: 3 }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("3")
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "title" }, "边缘留白：", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Switch, {
            checked: _ctx.padding,
            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.padding) = $event))
          }, null, 8, ["checked"])
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "tip" }, " 注意：若打印预览与实际样式不一致，请在弹出的打印窗口中勾选【背景图形】选项。 ", -1))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_Button, {
        class: "btn export",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expPDF()))
      }, {
        default: _withCtx(() => _cache[14] || (_cache[14] = [
          _createTextVNode("打印 / 导出 PDF")
        ])),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "btn close",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => _cache[15] || (_cache[15] = [
          _createTextVNode("关闭")
        ])),
        _: 1
      })
    ])
  ]))
}